export const ORGANIZATIONS = [
  "Bottom Line",
  "College Steps at Cypress Hills LDC",
  "Harlem Children's Zone",
  "HEAF",
  "Options Center at Riverside Goddard",
  "University Settlement",
  "New Settlement"
]